module.exports = __webpack_public_path__ + "static/media/GillSans.bf189e03.svg";